module.exports = {
  footerText: 'Copyright VietLook © 2020',
};
